/**
 * authMixin — starea și metodele comune pentru utilizatorul autentificat.
 * Oferă: currentUser, fetchCurrentUser(), logout().
 * Ascultă evenimentele globale user-authenticated / user-logged-out emise de SiteNavbar.
 */
export default {
    data() {
        return {
            currentUser: null,
        };
    },

    mounted() {
        window.addEventListener('user-authenticated', this._onUserAuthenticated);
        window.addEventListener('user-logged-out', this._onUserLoggedOut);
    },

    beforeUnmount() {
        window.removeEventListener('user-authenticated', this._onUserAuthenticated);
        window.removeEventListener('user-logged-out', this._onUserLoggedOut);
    },

    methods: {
        async fetchCurrentUser() {
            const token = window.localStorage.getItem('auth_token');
            if (!token) return;
            try {
                const response = await window.axios.get('/auth/me');
                this.currentUser = response.data?.user || null;
            } catch {
                window.localStorage.removeItem('auth_token');
                delete window.axios.defaults.headers.common.Authorization;
            }
        },

        async logout() {
            try {
                await window.axios.post('/auth/logout');
            } catch {
                // ignoră erori — stergem întotdeauna starea locală
            }
            window.localStorage.removeItem('auth_token');
            delete window.axios.defaults.headers.common.Authorization;
            this.currentUser = null;
            window.dispatchEvent(new CustomEvent('user-logged-out'));
            this.$router.push({ name: 'home' });
        },

        _onUserAuthenticated(e) {
            this.currentUser = e.detail;
        },

        _onUserLoggedOut() {
            this.currentUser = null;
        },
    },
};
